module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalSize": 'small',
      "modalTitle": 'Edit Expression'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', {
    on: {
      "validation": _vm.validation
    }
  }, [_c('FormulateInput', {
    attrs: {
      "label": "Type",
      "type": "select",
      "options": _vm.expressionTypeOptions,
      "validation": "required"
    },
    on: {
      "input": function($event) {
        _vm.hasErrors = false
      }
    },
    model: {
      value: (_vm.model.expression_type),
      callback: function($$v) {
        _vm.$set(_vm.model, "expression_type", $$v)
      },
      expression: "model.expression_type"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "label": "Negate",
      "type": "checkbox"
    },
    model: {
      value: (_vm.model.negate),
      callback: function($$v) {
        _vm.$set(_vm.model, "negate", $$v)
      },
      expression: "model.negate"
    }
  }), _vm._v(" "), (_vm.model.expression_type == 'rule') ? [_c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.fieldOptions,
      "label": "Field",
      "validation": "required"
    },
    model: {
      value: (_vm.model.field),
      callback: function($$v) {
        _vm.$set(_vm.model, "field", $$v)
      },
      expression: "model.field"
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "radio",
      "options": _vm.opOptions
    },
    model: {
      value: (_vm.model.operator),
      callback: function($$v) {
        _vm.$set(_vm.model, "operator", $$v)
      },
      expression: "model.operator"
    }
  }), _vm._v(" "), (_vm.valuesOptions && _vm.currentOp && _vm.currentOp.arity == 2) ? _c('FormulateInput', {
    attrs: {
      "type": "select",
      "options": _vm.valuesOptions,
      "label": "Value(s)",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.valuesOptions && _vm.currentOp && _vm.currentOp.arity == 'n') ? _c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "wrapper-class": ['multiple-choices'],
      "options": _vm.valuesOptions,
      "label": "Value(s)",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.currentOp && _vm.currentOp.arity == 2) ? _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Value",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : (_vm.currentOp && _vm.currentOp.arity == 'n') ? _c('FormulateInput', {
    attrs: {
      "type": "text",
      "label": "Value(s)",
      "help": "Use a comma to separate values",
      "validation": "required"
    },
    model: {
      value: (_vm.model.values),
      callback: function($$v) {
        _vm.$set(_vm.model, "values", $$v)
      },
      expression: "model.values"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.expression) ? [_c('h4', [_vm._v("Advanced")]), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteExpression
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete")])] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9d8bb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BooleanExpressionModal.vue
// module id = 681
// module chunks = 0